/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react'
import Grid from '@material-ui/core/Grid'
import {
  FormControl,
  Typography,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import { MultiSelect } from 'react-multi-select-component'
import { DateTimePicker } from '@material-ui/pickers'
import EditIcon from '@material-ui/icons/Edit'
import CalendarTodayIcon from '@material-ui/icons/CalendarTodayOutlined'

import moment, { Moment } from 'config/moment'
import { MULTI_SELECT_STRINGS } from 'consts/strings'
import { Dialog, UploadButton, snackbar } from 'components'
import { STRINGS, ERRORS } from 'consts'
import { useCheckFormErrors, useApiCall } from 'hooks'
import { UserContext } from 'contexts'
import { getUserRole, Role } from 'utils/roles'
import { CustomFormControlLabel } from 'components/CustomFormControlLabel'
import { CustomCheckbox } from 'components/CustomCheckbox'
import { PrizeCategory } from 'consts/prize'
import VisitsFilter from 'features/Main/Notifications/components/filters/VisitsFilter'
import DateRangeFilter from 'features/Main/Notifications/components/filters/DateRangeFilter'
import RewardFilter from 'features/Main/Notifications/components/filters/RewardFilter'
import { TabPanel } from 'components/Dialog/TabPanel'
import CustomTextField from 'components/CustomTextField'
import { ConfigUtils } from 'utils/config'
import {
  TimeRestrictionConfig,
  TimeRestrictionConfig as TimeRestrictionConfigType,
} from 'components/TimeRestrictionConfig'
import { resizeFile } from 'utils'

import { REWARD_TYPE_BY_PRIZES } from '../../../Memberships/Prizes/components/constants'
import { PartnerIntegration } from '../../../components/PartnerIntegration'
import { useStyles } from '../../../ManualRewards/components/CreateManualRewardDialog/styles'
import { campaignDialogStyle, campaignDialogContentStyle } from '../campaignDialogStyle'
import {
  getCampaignDialogTabs,
  getCampaignPopUpTabIndex,
  getCampaignEmailTabIndex,
  isCampaignPopUpsEnabled,
  isCampaignEmailEnabled,
  shouldShowPushImageUpload,
} from '../campaignFeatureFlags'
import { updateCampaign, fetchPushUserCount, uploadPopUpImage, getCampaign } from '../../api'
import { createCampaignEmail, updateCampaignEmail, getCampaignEmail } from '../../campaignEmailsApi'
import { Tag } from '../../../Tags/types'
import {
  Campaign,
  UpdateCampaignPayload,
  UpdateCampaignResponse,
  DataParams,
  DataResponse,
  UploadPopUpImageResponse,
} from '../../types'
import {
  CAMPAIGN_EMAIL_HTML_MAX_LENGTH,
  CAMPAIGN_EMAIL_SUBJECT_MAX_LENGTH,
  CreateCampaignEmailPayload,
  CreateCampaignEmailResponse,
  UpdateCampaignEmailData,
  UpdateCampaignEmailResponse,
} from '../../campaignEmailsTypes'
import { updatePrize, createPrize } from '../../../Prizes/api'
import { updateNotification, createNotification } from '../../../Notifications/api'
import {
  UpdatePrizeData,
  UpdatePrizeResponse,
  CreatePrizePayload,
  CreatePrizeResponse,
} from '../../../Prizes/types'
import {
  UpdateNotificationData,
  UpdateNotificationResponse,
  CreateNotificationPayload,
  CreateNotificationResponse,
} from '../../../Notifications/types'

interface ValidationData {
  toteatEnabled: boolean
  tucanCategory?: PrizeCategory
  toteatCategory?: PrizeCategory
  activeReward?: boolean
  activePush?: boolean
  activePopUp?: boolean
  activeEmail?: boolean
  isCampaignPopUpsEnabled?: boolean
  isCampaignEmailEnabled?: boolean
  hasPrizeIconPreview?: boolean
  hasPrizeImagePreview?: boolean
  hasPopUpImagePreview?: boolean
}

interface TagOption {
  label: string
  value: number
}

const rules = {
  title: [
    {
      validate: (title: string) => {
        if (!title || typeof title !== 'string' || title.trim().length === 0) {
          return false
        }
        return true
      },
      message: 'El título es requerido',
      validateEmpty: true,
    },
    {
      validate: (title: string) => {
        if (!title || typeof title !== 'string') {
          return true
        }
        return title.length <= 100
      },
      message: 'Máximo 100 caracteres',
    },
  ],
  description: [
    {
      validate: (description: string) => {
        if (!description || typeof description !== 'string' || description.trim().length === 0) {
          return false
        }
        return true
      },
      message: 'La descripción es requerida',
      validateEmpty: true,
    },
    {
      validate: (description: string) => {
        if (!description || typeof description !== 'string') {
          return true
        }
        return description.length <= 255
      },
      message: 'Máximo 255 caracteres',
    },
  ],
  startDate: [
    {
      validate: (value: Moment | null) => !!value,
      message: 'La fecha de inicio es requerida',
      validateEmpty: true,
    },
  ],
  prizeTitle: [
    {
      validate: (title: string, data: ValidationData) => {
        const { activeReward } = data
        if (activeReward && (!title || title.trim().length === 0)) {
          return false
        }
        return true
      },
      message: 'El título es requerido',
      validateEmpty: true,
    },
    {
      validate: (title: string) => !title || title.length <= 70,
      message: 'Máximo 70 caracteres',
    },
  ],
  prizeShortTitle: [
    {
      validate: (shortTitle: string, data: ValidationData) => {
        const { activeReward } = data
        if (activeReward && (!shortTitle || shortTitle.trim().length === 0)) {
          return false
        }
        return true
      },
      message: 'El título secundario es requerido',
      validateEmpty: true,
    },
    {
      validate: (shortTitle: string) => !shortTitle || shortTitle.length <= 100,
      message: 'Máximo 100 caracteres',
    },
  ],
  pushTitle: [
    {
      validate: (title?: string, data?: ValidationData) => {
        const { activePush } = data || {}
        if (activePush && (!title || title.trim().length === 0)) {
          return false
        }
        return true
      },
      message: 'El título push es requerido',
      validateEmpty: true,
    },
    {
      validate: (title?: string) => (title ? title.length <= 30 : true),
      message: 'Máximo 30 caracteres',
    },
  ],
  pushDescription: [
    {
      validate: (description?: string, data?: ValidationData) => {
        const { activePush } = data || {}
        if (activePush && (!description || description.trim().length === 0)) {
          return false
        }
        return true
      },
      message: 'La descripción push es requerida',
      validateEmpty: true,
    },
    {
      validate: (description?: string) => (description ? description.length <= 100 : true),
      message: 'Máximo 100 caracteres',
    },
  ],
  toteatBenefitId: [
    {
      validate: (value: string, data: ValidationData) => {
        const { toteatEnabled, toteatCategory } = data
        if (toteatEnabled && toteatCategory === PrizeCategory.Checkout) {
          return value.trim().length > 0
        }
        return true
      },
      message: 'El ID de beneficio POS es requerido',
      validateEmpty: true,
    },
  ],
  skusList: [
    {
      validate: (skusList: string[], data: ValidationData) => {
        const { toteatEnabled, toteatCategory } = data
        if (toteatEnabled && toteatCategory === PrizeCategory.General) {
          return skusList.length > 0
        }
        return true
      },
      message: 'El SKU es requerido',
    },
  ],
  visitsFilter: [
    {
      validate: (visitsFilter: string | null) =>
        visitsFilter == null ? true : parseInt(visitsFilter, 10) <= 1000,
      message: 'Máximo permitido: 1000',
    },
  ],
  prizeIcon: [
    {
      validate: (file: File | null, data: ValidationData) => {
        const { activeReward, hasPrizeIconPreview } = data
        if (activeReward) {
          return !!file || !!hasPrizeIconPreview
        }
        return true
      },
      message: 'El icono del reward es requerido',
      validateEmpty: true,
    },
  ],
  prizeImage: [
    {
      validate: (file: File | null, data: ValidationData) => {
        const {
          activeReward,
          activePush,
          hasPrizeImagePreview,
          isCampaignPopUpsEnabled: popUpsEnabled,
        } = data
        if (activeReward && activePush && !popUpsEnabled) {
          return !!file || !!hasPrizeImagePreview
        }
        return true
      },
      message: 'La imagen de la push es requerida',
      validateEmpty: true,
    },
  ],
  popUpImageId: [
    {
      validate: (value: string | undefined, data: ValidationData) => {
        const { activePopUp, hasPopUpImagePreview, isCampaignPopUpsEnabled: popUpsEnabled } = data
        if (popUpsEnabled && activePopUp && !value?.trim() && !hasPopUpImagePreview) {
          return false
        }
        return true
      },
      message: 'La imagen del pop-up es requerida',
      validateEmpty: true,
    },
  ],
  emailSubject: [
    {
      validate: (subject?: string, data?: ValidationData) => {
        const { activeEmail, isCampaignEmailEnabled: emailEnabled } = data || {}
        if (emailEnabled && activeEmail && (!subject || subject.trim().length === 0)) {
          return false
        }
        return true
      },
      message: 'El asunto del email es requerido',
      validateEmpty: true,
    },
    {
      validate: (subject?: string) =>
        !subject || subject.length <= CAMPAIGN_EMAIL_SUBJECT_MAX_LENGTH,
      message: `Máximo ${CAMPAIGN_EMAIL_SUBJECT_MAX_LENGTH} caracteres`,
    },
  ],
  emailHtml: [
    {
      validate: (html?: string, data?: ValidationData) => {
        const { activeEmail, isCampaignEmailEnabled: emailEnabled } = data || {}
        if (emailEnabled && activeEmail && (!html || html.trim().length === 0)) {
          return false
        }
        return true
      },
      message: 'El HTML del email es requerido',
      validateEmpty: true,
    },
    {
      validate: (html?: string) => !html || html.length <= CAMPAIGN_EMAIL_HTML_MAX_LENGTH,
      message: `Máximo ${CAMPAIGN_EMAIL_HTML_MAX_LENGTH} caracteres`,
    },
  ],
}

interface UpdateCampaignDialogProps {
  handleClose: () => void
  campaignToUpdate: Campaign
  onDone: (updatedCampaign: Campaign) => void
  tags: Tag[]
  isReadOnly?: boolean
}

const UpdateCampaignDialog: React.FC<UpdateCampaignDialogProps> = ({
  handleClose,
  campaignToUpdate,
  onDone,
  tags,
  isReadOnly = false,
}) => {
  const classes = useStyles()
  const { admin } = useContext(UserContext)
  const userRole = getUserRole(admin)
  const isMarketing = userRole === Role.Marketing

  // Helper function to prevent updates when campaign has started or in read-only mode
  const noop = () => {
    // Intentionally empty - prevents state updates when campaign has started or in read-only mode
  }

  // Campaign fields
  const [title, setTitle] = useState(campaignToUpdate.title || '')
  const [description, setDescription] = useState(campaignToUpdate.description || '')
  const [startDate, setStartDate] = useState<Moment | null>(
    campaignToUpdate.startDate ? moment(campaignToUpdate.startDate) : null,
  )
  const [endDate, setEndDate] = useState<Moment | null>(
    campaignToUpdate.endDate ? moment(campaignToUpdate.endDate) : null,
  )
  const [enabled, setEnabled] = useState(campaignToUpdate.enabled ?? true)
  const [activeReward, setActiveReward] = useState(campaignToUpdate.activeReward)
  const [activePush, setActivePush] = useState(campaignToUpdate.activePush)
  const [activePopUp, setActivePopUp] = useState(campaignToUpdate.activePopUp ?? false)
  const [activeEmail, setActiveEmail] = useState(campaignToUpdate.activeEmail)

  // Segmentation fields
  const [tagsSelected, setTagsSelected] = useState<TagOption[]>(
    campaignToUpdate.tags?.map(t => ({ label: t.title, value: t.id })) || [],
  )
  const [excludedTagsSelected, setExcludedTagsSelected] = useState<TagOption[]>(
    campaignToUpdate.excludedTags?.map(t => ({ label: t.title, value: t.id })) || [],
  )
  const [allTagsAreRequired, setAllTagsAreRequired] = useState(campaignToUpdate.allTagsAreRequired)
  const [includeAbandoners, setIncludeAbandoners] = useState(
    campaignToUpdate.includeAbandoners ?? false,
  )
  const [visitsFilter, setVisitsFilter] = useState<string | null>(
    campaignToUpdate.visitsValue?.toString() || null,
  )
  const [visitsOperator, setVisitsOperator] = useState<'==' | '>' | '<'>(
    (campaignToUpdate.visitsOperator as '==' | '>' | '<') || '==',
  )
  const [dateFrom, setDateFrom] = useState<Moment | null>(
    campaignToUpdate.dateFrom ? moment(campaignToUpdate.dateFrom) : null,
  )
  const [dateTo, setDateTo] = useState<Moment | null>(
    campaignToUpdate.dateTo ? moment(campaignToUpdate.dateTo) : null,
  )
  const [rewardId, setRewardId] = useState<string>(campaignToUpdate.rewardId?.toString() || '')
  const [invertedLogic, setInvertedLogic] = useState<boolean>(campaignToUpdate.rewardInverted)

  // Prize fields - pre-populate from existing prize if available
  const existingPrize = campaignToUpdate.prize
  const [prizeTitle, setPrizeTitle] = useState(existingPrize?.title || '')
  const [prizeShortTitle, setPrizeShortTitle] = useState(existingPrize?.additionalText || '')
  const [prizeIcon, setPrizeIcon] = useState<File | null>(null)
  const [prizeIconPreview, setPrizeIconPreview] = useState(existingPrize?.iconUrl || '')
  const [prizeImage, setPrizeImage] = useState<File | null>(null)
  const [prizeImagePreview, setPrizeImagePreview] = useState(existingPrize?.imageUrl || '')
  const [rewardType, setRewardType] = useState(existingPrize?.rewardType || 'M')
  const [toteatBenefitId, setToteatBenefitId] = useState<string>(
    existingPrize?.toteatBenefitId || '',
  )
  const [currentSku, setCurrentSku] = useState<string>('')
  const [skusList, setSkusList] = useState<string[]>(existingPrize?.skus?.map(sku => sku.sku) || [])
  const [storesEnabled, setStoresEnabled] = useState(existingPrize?.storesEnabled ?? true)
  const [tucanEnabled, setTucanEnabled] = useState(existingPrize?.tucanEnabled ?? false)
  const [toteatEnabled, setToteatEnabled] = useState(existingPrize?.toteatEnabled ?? false)
  const [toteatCategory, setToteatCategory] = useState<PrizeCategory | undefined>(
    existingPrize?.toteatCategory || PrizeCategory.Checkout,
  )
  const [tucanCategory, setTucanCategory] = useState<PrizeCategory | undefined>(
    existingPrize?.tucanCategory || PrizeCategory.Checkout,
  )
  const [timeRestriction, setTimeRestriction] = useState<TimeRestrictionConfigType>({
    timeRestrictionEnabled: existingPrize?.timeRestrictionEnabled || false,
    allowedDays: existingPrize?.allowedDays || [],
    startTime: existingPrize?.startTime || '00:00',
    endTime: existingPrize?.endTime || '23:59',
  })

  // Push fields - pre-populate from existing notification if available
  const existingNotification = campaignToUpdate.notification
  const [pushTitle, setPushTitle] = useState(existingNotification?.title || '')
  const [pushDescription, setPushDescription] = useState(existingNotification?.body || '')

  const [popUpImagePreview, setPopUpImagePreview] = useState(campaignToUpdate.popUpImageUrl || '')
  const [popUpImageId, setPopUpImageId] = useState(campaignToUpdate.popUpImageId || '')
  const [isUploadingPopUpImage, setIsUploadingPopUpImage] = useState(false)

  const existingEmail = campaignToUpdate.email
  const [emailSubject, setEmailSubject] = useState(existingEmail?.subject || '')
  const [emailHtml, setEmailHtml] = useState(existingEmail?.html || '')
  const [emailId, setEmailId] = useState<number | undefined>(campaignToUpdate.emailId)

  const isCampaignProcessed = Boolean(campaignToUpdate.processingCompletedAt)
  const [userCount, setUserCount] = useState<number | null>(
    isCampaignProcessed ? campaignToUpdate.affectedUsersCount ?? 0 : null,
  )
  const [hasPartnerErrors, setHasPartnerErrors] = useState(false)
  const [tabIndex, setTabIndex] = useState(0)
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false)

  // Ajustar tabIndex si se desactiva el reward y estamos en el tab de Horarios
  /* useEffect(() => {
    if (!activeReward && tabIndex === 3) {
      // Si se desactiva el reward y estamos en Horarios, volver al tab de Beneficio
      setTabIndex(2)
    }
  }, [activeReward, tabIndex]) */

  const tagsForSelect = tags.map(el => ({ label: el.title, value: el.id }))
  const includeTagOptions = tagsForSelect.filter(
    tag => !excludedTagsSelected.some(selected => selected.value === tag.value),
  )
  const excludeTagOptions = tagsForSelect.filter(
    tag => !tagsSelected.some(selected => selected.value === tag.value),
  )

  const [updateCampaignApi, isLoading] = useApiCall<UpdateCampaignPayload, UpdateCampaignResponse>(
    updateCampaign,
  )
  const [updatePrizeApi] = useApiCall<UpdatePrizeData, UpdatePrizeResponse>(updatePrize)
  const [createPrizeApi] = useApiCall<CreatePrizePayload, CreatePrizeResponse>(createPrize)
  const [updateNotificationApi] = useApiCall<UpdateNotificationData, UpdateNotificationResponse>(
    updateNotification,
  )
  const [createNotificationApi] = useApiCall<CreateNotificationPayload, CreateNotificationResponse>(
    createNotification,
  )
  const [createCampaignEmailApi] = useApiCall<
    CreateCampaignEmailPayload,
    CreateCampaignEmailResponse
  >(createCampaignEmail)
  const [updateCampaignEmailApi] = useApiCall<UpdateCampaignEmailData, UpdateCampaignEmailResponse>(
    updateCampaignEmail,
  )
  const [getCampaignEmailApi] = useApiCall<number, CreateCampaignEmailResponse>(getCampaignEmail)
  const [uploadPopUpImageApi] = useApiCall<File, UploadPopUpImageResponse>(uploadPopUpImage)
  const [getCampaignApi] = useApiCall<number, { campaign: Campaign }>(getCampaign)
  const [requestData, isRequestingData] = useApiCall<DataParams, DataResponse>(fetchPushUserCount)

  const handleSetTags = async (e: TagOption[]) => {
    const excludedIds = new Set(excludedTagsSelected.map(tag => tag.value))
    setTagsSelected(e.filter(tag => !excludedIds.has(tag.value)))
  }

  const handleSetExcludedTags = async (e: TagOption[]) => {
    const includedIds = new Set(tagsSelected.map(tag => tag.value))
    setExcludedTagsSelected(e.filter(tag => !includedIds.has(tag.value)))
  }

  const handleAllTagsAreRequiredChange: React.ChangeEventHandler<HTMLInputElement> = () => {
    setAllTagsAreRequired(!allTagsAreRequired)
  }

  const handleStartDateChange = (date: Moment | null) => {
    setStartDate(date)
  }

  const handleEndDateChange = (date: Moment | null) => {
    setEndDate(date)
  }

  const handlePrizeIconChange = async (file: File) => {
    setPrizeIconPreview(URL.createObjectURL(file))
    const newIcon = await resizeFile(file, 192, 192)
    setPrizeIcon(newIcon)
  }

  const handlePrizeImageChange = async (file: File) => {
    setPrizeImagePreview(URL.createObjectURL(file))
    const newImage = await resizeFile(file, 960, 640)
    setPrizeImage(newImage)
  }

  const handlePopUpImageChange = async (file: File) => {
    const localPreviewUrl = URL.createObjectURL(file)
    setPopUpImagePreview(localPreviewUrl)
    setIsUploadingPopUpImage(true)
    try {
      const { popUpImageId: uploadedId, popUpImageUrl } = await uploadPopUpImageApi(file)
      setPopUpImageId(uploadedId)
      if (popUpImageUrl) {
        URL.revokeObjectURL(localPreviewUrl)
        setPopUpImagePreview(popUpImageUrl)
      }
    } catch (err) {
      console.error(err)
      snackbar.show('No se pudo subir la imagen del pop-up. Intente de nuevo.')
      URL.revokeObjectURL(localPreviewUrl)
      setPopUpImagePreview(campaignToUpdate.popUpImageUrl || '')
      setPopUpImageId(campaignToUpdate.popUpImageId || '')
    } finally {
      setIsUploadingPopUpImage(false)
    }
  }

  const handleRewardTypeSelect = (event: React.ChangeEvent<{ value: unknown }>) => {
    setRewardType(event.target.value as string)
  }

  const handleFetchPushUserCount = async () => {
    // Processed campaigns keep the snapshot from the cron — no live COUNT.
    if (campaignToUpdate.processingCompletedAt) {
      setUserCount(campaignToUpdate.affectedUsersCount ?? 0)
      return
    }

    try {
      const tagsSelectedId = tagsSelected.map((tag: { value: number }) => tag.value)
      const excludedTagsSelectedId = excludedTagsSelected.map((tag: { value: number }) => tag.value)

      const filterDates =
        dateFrom && dateTo
          ? {
              dateFrom: dateFrom?.toISOString(),
              dateTo: dateTo?.toISOString(),
            }
          : undefined

      const data = await requestData({
        visitsValue:
          visitsFilter !== null && visitsFilter.length ? parseInt(visitsFilter, 10) : undefined,
        visitsOperator,
        ...filterDates,
        rewardId: rewardId ? parseInt(rewardId, 10) : undefined,
        rewardInverted: invertedLogic,
        tagIds: tagsSelectedId,
        excludedTagIds: excludedTagsSelectedId,
        allTagsAreRequired,
        includeAbandoners,
      })

      setUserCount(data.count)
    } catch (err) {
      console.error(err)
      snackbar.show('No se pudo calcular la cantidad de usuarios. Intente de nuevo.')
    }
  }

  useEffect(() => {
    handleFetchPushUserCount()
  }, [
    rewardId,
    invertedLogic,
    tagsSelected,
    excludedTagsSelected,
    allTagsAreRequired,
    includeAbandoners,
    visitsFilter,
    visitsOperator,
    dateFrom,
    dateTo,
  ])

  // Update prize icon and image preview when existingPrize changes
  useEffect(() => {
    if (existingPrize?.iconUrl && !prizeIcon) {
      setPrizeIconPreview(existingPrize.iconUrl)
    }
    if (existingPrize?.imageUrl && !prizeImage) {
      setPrizeImagePreview(existingPrize.imageUrl)
    }
  }, [existingPrize, prizeIcon, prizeImage])

  useEffect(() => {
    if (campaignToUpdate.popUpImageId && !popUpImageId) {
      setPopUpImageId(campaignToUpdate.popUpImageId)
    }
    if (campaignToUpdate.popUpImageUrl && !popUpImagePreview) {
      setPopUpImagePreview(campaignToUpdate.popUpImageUrl)
    }
  }, [campaignToUpdate, popUpImageId, popUpImagePreview])

  useEffect(() => {
    if (!campaignToUpdate.popUpImageId || campaignToUpdate.popUpImageUrl || popUpImagePreview) {
      return
    }

    getCampaignApi(campaignToUpdate.id)
      .then(({ campaign }) => {
        if (campaign.popUpImageUrl) {
          setPopUpImagePreview(campaign.popUpImageUrl)
        }
        if (campaign.popUpImageId) {
          setPopUpImageId(campaign.popUpImageId)
        }
      })
      .catch(noop)
  }, [campaignToUpdate.id, campaignToUpdate.popUpImageId, campaignToUpdate.popUpImageUrl])

  useEffect(() => {
    if (existingEmail?.subject || existingEmail?.html) {
      return
    }
    if (!campaignToUpdate.emailId) {
      return
    }

    getCampaignEmailApi(campaignToUpdate.emailId)
      .then(({ campaignEmail }) => {
        setEmailSubject(campaignEmail.subject)
        setEmailHtml(campaignEmail.html)
        setEmailId(campaignToUpdate.emailId)
      })
      .catch(noop)
  }, [campaignToUpdate.emailId, existingEmail])

  const getRequiredFields = () => {
    const requiredFields: string[] = ['startDate', 'title', 'description']

    if (activeReward) {
      requiredFields.push('prizeTitle', 'prizeShortTitle')
      // Only require icon if there's no existing prize or no preview
      if (!existingPrize || !prizeIconPreview) {
        requiredFields.push('prizeIcon')
      }
    }

    if (activePush) {
      requiredFields.push('pushTitle', 'pushDescription')
      if (shouldShowPushImageUpload() && activeReward) {
        if (!existingPrize?.imageUrl && !prizeImagePreview) {
          requiredFields.push('prizeImage')
        }
      }
    }

    if (isCampaignEmailEnabled() && activeEmail) {
      requiredFields.push('emailSubject', 'emailHtml')
    }

    if (toteatEnabled) {
      if (toteatCategory === PrizeCategory.General) {
        requiredFields.push('skusList')
      } else if (toteatCategory === PrizeCategory.Checkout) {
        requiredFields.push('toteatBenefitId')
      }
    }

    return requiredFields
  }

  const fields = {
    title,
    description,
    startDate,
    prizeTitle,
    prizeShortTitle,
    prizeIcon,
    prizeImage,
    pushTitle,
    pushDescription,
    emailSubject,
    emailHtml,
    toteatEnabled,
    toteatBenefitId,
    skusList,
    tucanCategory,
    toteatCategory,
    visitsFilter,
    activeReward,
    activePush,
    activePopUp: isCampaignPopUpsEnabled() ? activePopUp : campaignToUpdate.activePopUp,
    activeEmail: isCampaignEmailEnabled() ? activeEmail : campaignToUpdate.activeEmail,
    popUpImageId,
    isCampaignPopUpsEnabled: isCampaignPopUpsEnabled(),
    isCampaignEmailEnabled: isCampaignEmailEnabled(),
    hasPrizeIconPreview: !!prizeIconPreview,
    hasPrizeImagePreview: !!prizeImagePreview,
    hasPopUpImagePreview: !!(popUpImagePreview || campaignToUpdate.popUpImageId),
  }
  const { hasErrors, isAnyFieldEmpty, errors } = useCheckFormErrors(
    fields,
    rules,
    getRequiredFields(),
  )
  const isCampaignStarted = !!campaignToUpdate.processingStartedAt
  // isReadOnlyOrStarted se usa para campos que NO deben ser editables cuando está en modo lectura o procesada
  const isReadOnlyOrStarted = isReadOnly || isCampaignStarted

  // Only disable button during loading or when in read-only mode, not based on validation
  const isSubmitDisabled = isLoading || isReadOnly

  const onUpdateCampaign = async () => {
    // Mark that user has attempted to submit
    setHasAttemptedSubmit(true)

    // Check for validation errors
    if (hasErrors || isAnyFieldEmpty || hasPartnerErrors) {
      // Use setTimeout to ensure snackbar renders before return
      setTimeout(() => {
        snackbar.show('Error al actualizar campaña. Verifique los campos obligatorios.')
      }, 0)
      return
    }

    if (!startDate) {
      // Use setTimeout to ensure snackbar renders before return
      setTimeout(() => {
        snackbar.show('Error al actualizar campaña. Verifique los campos obligatorios.')
      }, 0)
      return
    }

    let { prizeId } = campaignToUpdate
    let { notificationId } = campaignToUpdate

    try {
      // Update or create prize if activeReward is true
      if (activeReward) {
        if (!prizeTitle || !prizeShortTitle) {
          snackbar.show('Todos los campos del premio son requeridos.')
          return
        }

        // Use endDate if available, otherwise use startDate
        /*  const expirationDate = endDate || startDate
        if (!expirationDate) {
          snackbar.show('La fecha de fin de la campaña es requerida para el premio.')
          return
        } */

        // If there's an existing prize, update it; otherwise create a new one
        if (existingPrize && campaignToUpdate.prizeId) {
          // Format timeRestriction to ensure HH:MM format (remove seconds if present)
          const formattedTimeRestriction = {
            ...timeRestriction,
            startTime: timeRestriction.startTime
              ? timeRestriction.startTime.substring(0, 5)
              : '00:00',
            endTime: timeRestriction.endTime ? timeRestriction.endTime.substring(0, 5) : '23:59',
          }

          // If campaign has started, only update editable fields (title, description, icon, image, timeRestriction, expiration)
          // But we need to include startDate from existing prize for expiration validation
          const prizePayload: UpdatePrizeData = {
            id: campaignToUpdate.prizeId,
            payload: {
              title: prizeTitle,
              additionalText: prizeShortTitle,
              ...(prizeIcon ? { icon: prizeIcon } : {}),
              ...(prizeImage ? { image: prizeImage } : {}),
              expiration: (() => {
                if (endDate) {
                  return endDate.toISOString()
                }
                if (existingPrize?.expiration !== undefined) {
                  return existingPrize.expiration
                }
                return undefined
              })(),
              timeRestriction: formattedTimeRestriction,
              // Only include non-editable fields if campaign hasn't started
              ...(!isCampaignStarted && {
                rewardType: rewardType || 'M',
                active: true,
                storesEnabled,
                tucanEnabled,
                toteatEnabled,
                tucanCategory,
                toteatCategory,
                toteatBenefitId: toteatBenefitId || undefined,
                skus: skusList,
                tagsSelected: tagsSelected.map(t => ({ label: t.label, value: t.value })),
                allTagsAreRequired,
                startDate: startDate.toISOString(),
              }),
              // If campaign has started, include startDate from existing prize for validation
              ...(isCampaignStarted &&
                existingPrize?.startDate && {
                  startDate: existingPrize.startDate,
                }),
            },
          }

          await updatePrizeApi(prizePayload)
          prizeId = campaignToUpdate.prizeId
        } else {
          // Create new prize
          if (!prizeIcon) {
            snackbar.show('El icono del premio es requerido para crear un nuevo premio.')
            return
          }

          // Format timeRestriction to ensure HH:MM format (remove seconds if present)
          const formattedTimeRestriction = {
            ...timeRestriction,
            startTime: timeRestriction.startTime
              ? timeRestriction.startTime.substring(0, 5)
              : '00:00',
            endTime: timeRestriction.endTime ? timeRestriction.endTime.substring(0, 5) : '23:59',
          }

          const prizePayload: CreatePrizePayload = {
            title: prizeTitle,
            additionalText: prizeShortTitle,
            icon: prizeIcon,
            image: prizeImage || undefined,
            rewardType: rewardType || 'M',
            active: true,
            storesEnabled,
            tucanEnabled,
            toteatEnabled,
            tucanCategory,
            toteatCategory,
            toteatBenefitId: toteatBenefitId || undefined,
            skus: skusList,
            tagsSelected: tagsSelected.map(t => ({ label: t.label, value: t.value })),
            allTagsAreRequired,
            startDate: startDate.toISOString(),
            expiration: endDate ? endDate.toISOString() : undefined,
            timeRestriction: formattedTimeRestriction,
          }

          const { prize } = await createPrizeApi(prizePayload)
          prizeId = prize.id
        }
      }

      // Update or create notification if activePush is true
      // Skip notification update if campaign has already started (push fields are not editable)
      if (activePush && !isCampaignStarted) {
        if (!pushTitle || !pushDescription) {
          snackbar.show('Todos los campos de la push son requeridos.')
          return
        }

        const tagsSelectedId = tagsSelected.map((tag: { value: number }) => tag.value)

        // If there's an existing notification, update it; otherwise create a new one
        if (existingNotification && campaignToUpdate.notificationId) {
          const notificationPayload: UpdateNotificationData = {
            id: campaignToUpdate.notificationId,
            payload: {
              title: pushTitle,
              body: pushDescription,
              scheduled: startDate.toISOString(),
              tagIds: tagsSelectedId,
              allTagsAreRequired,
              visitsOperator: visitsFilter !== null ? visitsOperator : undefined,
              visitsValue: visitsFilter !== null ? parseInt(visitsFilter, 10) : undefined,
              dateFrom: dateFrom?.toISOString(),
              dateTo: dateTo?.toISOString(),
              rewardId: rewardId ? parseInt(rewardId, 10) : undefined,
              rewardInverted: invertedLogic,
            },
          }

          await updateNotificationApi(notificationPayload)
          notificationId = campaignToUpdate.notificationId
        } else {
          // Create new notification
          const notificationPayload: CreateNotificationPayload = {
            title: pushTitle,
            body: pushDescription,
            scheduled: startDate.toISOString(),
            tagIds: tagsSelectedId,
            allTagsAreRequired,
            visitsOperator: visitsFilter !== null ? visitsOperator : undefined,
            visitsValue: visitsFilter !== null ? parseInt(visitsFilter, 10) : undefined,
            dateFrom: dateFrom?.toISOString(),
            dateTo: dateTo?.toISOString(),
            rewardId: rewardId ? parseInt(rewardId, 10) : undefined,
            rewardInverted: invertedLogic,
          }

          const { notification } = await createNotificationApi(notificationPayload)
          notificationId = notification.id
        }
      } else if (activePush && isCampaignStarted) {
        // Keep existing notificationId if campaign has started
        notificationId = campaignToUpdate.notificationId
      }

      let nextEmailId = emailId || campaignToUpdate.emailId
      if (isCampaignEmailEnabled() && activeEmail && !isCampaignStarted) {
        if (!emailSubject.trim() || !emailHtml.trim()) {
          snackbar.show('Todos los campos del email son requeridos.')
          return
        }

        if (nextEmailId) {
          await updateCampaignEmailApi({
            id: nextEmailId,
            payload: {
              subject: emailSubject.trim(),
              html: emailHtml,
            },
          })
        } else {
          const { campaignEmail } = await createCampaignEmailApi({
            subject: emailSubject.trim(),
            html: emailHtml,
          })
          nextEmailId = campaignEmail.id
          setEmailId(campaignEmail.id)
        }
      }

      // Update campaign
      const tagsSelectedId = tagsSelected.map((tag: { value: number }) => tag.value)

      // Build campaign payload - exclude non-editable fields if campaign has started
      const campaignPayload: UpdateCampaignPayload = {
        id: campaignToUpdate.id,
        title: title || undefined,
        description: description || undefined,
        endDate: endDate?.toISOString() || undefined,
        enabled,
        emailId: nextEmailId,
        activeEmail: isCampaignEmailEnabled() ? activeEmail : campaignToUpdate.activeEmail,
        // Only include these fields if campaign hasn't started
        ...(!isCampaignStarted && {
          startDate: startDate.toISOString(),
          notificationId,
          prizeId,
          activeReward,
          activePush,
          ...(isCampaignPopUpsEnabled()
            ? {
                activePopUp,
                popUpImageId: activePopUp
                  ? popUpImageId || campaignToUpdate.popUpImageId || undefined
                  : undefined,
              }
            : {
                activePopUp: campaignToUpdate.activePopUp,
                popUpImageId: campaignToUpdate.popUpImageId,
              }),
          tagIds: tagsSelectedId,
          excludedTagIds: excludedTagsSelected.map((tag: { value: number }) => tag.value),
          allTagsAreRequired,
          visitsOperator: visitsFilter !== null ? visitsOperator : undefined,
          visitsValue: visitsFilter !== null ? parseInt(visitsFilter, 10) : undefined,
          dateFrom: dateFrom?.toISOString(),
          dateTo: dateTo?.toISOString(),
          rewardId: rewardId ? parseInt(rewardId, 10) : undefined,
          rewardInverted: invertedLogic,
          includeAbandoners,
        }),
        // If campaign has started, keep existing IDs but don't send non-editable fields
        ...(isCampaignStarted && {
          notificationId: campaignToUpdate.notificationId,
          prizeId: campaignToUpdate.prizeId,
          emailId: campaignToUpdate.emailId,
          activeEmail: campaignToUpdate.activeEmail,
        }),
      }

      const { campaign } = await updateCampaignApi(campaignPayload)
      onDone(campaign)
    } catch (err) {
      console.error(err)
      const errorMessage = err instanceof Error ? err.message : ERRORS.GENERIC_ERROR_MESSAGE
      snackbar.show(errorMessage)
    }
  }

  const handlePartnerValidationChange = (hasErrorsPartner: boolean) => {
    setHasPartnerErrors(hasErrorsPartner)
  }

  const hasAnyIntegration = ConfigUtils.hasAnyIntegrationEnabled()
  const isEcardEnabled = process.env.REACT_APP_ECARD_ENABLED === 'true'
  const campaignPopUpsEnabled = isCampaignPopUpsEnabled()
  const campaignEmailEnabled = isCampaignEmailEnabled()
  const showPushImageUpload = shouldShowPushImageUpload()
  const tabs = getCampaignDialogTabs(activeReward)
  const popUpTabIndex = getCampaignPopUpTabIndex(activeReward)
  const emailTabIndex = getCampaignEmailTabIndex(activeReward)

  useEffect(() => {
    const maxTabIndex = tabs.length - 1
    if (tabIndex > maxTabIndex) {
      setTabIndex(maxTabIndex)
    }
  }, [tabs.length, tabIndex])

  return (
    <Dialog
      title={isReadOnly ? 'Visualizar campaña' : 'Editar campaña'}
      isOpen
      maxWidth={false}
      showTabsActions={!isReadOnly}
      onCancel={handleClose}
      isLoading={isLoading || isUploadingPopUpImage}
      okButtonText="Guardar"
      okButtonProps={{ disabled: isSubmitDisabled, startIcon: <EditIcon /> }}
      onAccept={onUpdateCampaign}
      tabs={tabs}
      tabIndex={tabIndex}
      setTabIndex={setTabIndex}
      showUserCount
      isRequestingData={!isCampaignProcessed && isRequestingData}
      userCount={userCount!}
      userCountExtra={
        <div style={{ padding: '0px 24px 15px' }}>
          <CustomFormControlLabel
            control={
              <CustomCheckbox
                onChange={() => setIncludeAbandoners(!includeAbandoners)}
                checked={includeAbandoners}
                disabled={isReadOnlyOrStarted}
              />
            }
            label="Incluir también abandonadores"
          />
        </div>
      }
      style={campaignDialogStyle}
      contentStyle={campaignDialogContentStyle}
    >
      <Grid>
        {/* Tab 0 Campaña */}
        <TabPanel value={tabIndex} index={0} id="campana">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <CustomTextField
                label="Título"
                value={title}
                fullWidth
                onChange={e => setTitle(e.target.value)}
                disabled={isLoading || isReadOnly}
                maxLength={100}
                error={hasAttemptedSubmit && errors.title?.hasError}
                helperText={
                  hasAttemptedSubmit && errors.title?.hasError ? errors.title?.message : ''
                }
              />
            </Grid>
            <Grid item xs={12}>
              <CustomTextField
                label="Descripción"
                value={description}
                fullWidth
                onChange={e => setDescription(e.target.value)}
                disabled={isLoading || isReadOnly}
                multiline
                rows={3}
                maxLength={255}
                error={hasAttemptedSubmit && errors.description?.hasError}
                helperText={
                  hasAttemptedSubmit && errors.description?.hasError
                    ? errors.description?.message
                    : ''
                }
              />
            </Grid>
            <Grid item xs={12}>
              <DateTimePicker
                value={startDate}
                onChange={handleStartDateChange}
                autoOk
                disablePast
                format={STRINGS.DATE_TIME_FORMAT}
                initialFocusedDate={new Date()}
                disabled={isLoading || isReadOnlyOrStarted}
                label="Fecha de inicio*"
                required
                style={{ width: '100%' }}
                TextFieldComponent={props => (
                  <CustomTextField
                    {...props}
                    fullWidth
                    error={hasAttemptedSubmit && errors.startDate?.hasError}
                    helperText={hasAttemptedSubmit ? errors.startDate?.message : ''}
                    InputProps={{
                      ...props.InputProps,
                      endAdornment: (
                        <IconButton>
                          <CalendarTodayIcon style={{ width: 15, height: 15, color: '#6B7280' }} />
                        </IconButton>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <DateTimePicker
                value={endDate}
                onChange={handleEndDateChange}
                autoOk
                disablePast
                format={STRINGS.DATE_TIME_FORMAT}
                minDate={startDate || moment()}
                minDateMessage="La fecha de fin debe ser mayor o igual a la fecha de inicio"
                disabled={isLoading || isReadOnly}
                label="Fecha de fin"
                style={{ width: '100%' }}
                TextFieldComponent={props => (
                  <CustomTextField
                    {...props}
                    fullWidth
                    InputProps={{
                      ...props.InputProps,
                      endAdornment: (
                        <IconButton>
                          <CalendarTodayIcon style={{ width: 15, height: 15, color: '#6B7280' }} />
                        </IconButton>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomFormControlLabel
                control={
                  <CustomCheckbox
                    onChange={isReadOnly ? noop : e => setEnabled(e.target.checked)}
                    checked={enabled}
                    disabled={isReadOnly || isMarketing}
                  />
                }
                label="Habilitar campaña"
              />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Tab 1 Segmentar */}
        <TabPanel value={tabIndex} index={1} id="segmentar">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography className={classes.dialogSubTitle}>Tags a incluir</Typography>
              <FormControl className={classes.fullWidth}>
                <MultiSelect
                  options={includeTagOptions}
                  value={tagsSelected}
                  onChange={isReadOnlyOrStarted ? noop : handleSetTags}
                  labelledBy="Seleccionar Tags"
                  hasSelectAll={false}
                  className={`${classes.outlinedMultiSelect} ${
                    isReadOnlyOrStarted ? 'disabled' : ''
                  }`}
                  disabled={isReadOnlyOrStarted}
                  overrideStrings={MULTI_SELECT_STRINGS}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <CustomFormControlLabel
                control={
                  <CustomCheckbox
                    onChange={handleAllTagsAreRequiredChange}
                    checked={allTagsAreRequired}
                    disabled={isReadOnlyOrStarted}
                  />
                }
                label="Sólo usuarios con todos los tags seleccionados a incluir"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.dialogSubTitle}>Tags a excluir</Typography>
              <FormControl className={classes.fullWidth}>
                <MultiSelect
                  options={excludeTagOptions}
                  value={excludedTagsSelected}
                  onChange={isReadOnlyOrStarted ? noop : handleSetExcludedTags}
                  labelledBy="Seleccionar Tags a excluir"
                  hasSelectAll={false}
                  className={`${classes.outlinedMultiSelect} ${
                    isReadOnlyOrStarted ? 'disabled' : ''
                  }`}
                  disabled={isReadOnlyOrStarted}
                  overrideStrings={MULTI_SELECT_STRINGS}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography className={classes.dialogSubTitle}>Rango de visitantes</Typography>
              <Grid item xs={12}>
                <VisitsFilter
                  visitsFilter={visitsFilter}
                  setVisitsFilter={isReadOnlyOrStarted ? noop : setVisitsFilter}
                  visitsOperator={visitsOperator}
                  setVisitsOperator={isReadOnlyOrStarted ? noop : setVisitsOperator}
                  error={hasAttemptedSubmit && errors.visitsFilter?.hasError}
                  helperText={hasAttemptedSubmit ? errors.visitsFilter?.message : ''}
                  disabled={isReadOnlyOrStarted}
                />
              </Grid>
              <Grid item xs={12}>
                <DateRangeFilter
                  startDate={dateFrom}
                  setStartDate={isReadOnlyOrStarted ? noop : setDateFrom}
                  endDate={dateTo}
                  setEndDate={isReadOnlyOrStarted ? noop : setDateTo}
                  disabled={isReadOnlyOrStarted}
                />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Typography className={classes.dialogSubTitle}>Premios</Typography>
              <RewardFilter
                rewardId={rewardId}
                setRewardId={isReadOnlyOrStarted ? noop : setRewardId}
                invertedLogic={invertedLogic}
                setInvertedLogic={isReadOnlyOrStarted ? noop : setInvertedLogic}
                disabled={isReadOnlyOrStarted}
              />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Tab 2 Beneficio */}
        <TabPanel value={tabIndex} index={2} id="beneficio">
          <Grid container spacing={3}>
            <Grid item xs={12} className={classes.topCheckbox}>
              <CustomFormControlLabel
                control={
                  <CustomCheckbox
                    onChange={e => setActiveReward(e.target.checked)}
                    checked={activeReward}
                    disabled={isReadOnlyOrStarted}
                  />
                }
                label="Activar Reward"
              />
            </Grid>

            {activeReward && (
              <>
                <Grid item xs={12}>
                  <FormControl className={classes.fullWidth}>
                    <InputLabel
                      id="reward-type-select-label"
                      style={{ fontFamily: 'Montserrat', fontWeight: 400, fontSize: 14 }}
                    >
                      Tipo de premio
                    </InputLabel>
                    <Select
                      style={{ fontFamily: 'Montserrat', fontWeight: 400, fontSize: 14 }}
                      labelId="reward-type-select-label"
                      id="reward-type-select"
                      value={rewardType}
                      onChange={handleRewardTypeSelect}
                      fullWidth
                      disabled={isReadOnlyOrStarted}
                    >
                      {REWARD_TYPE_BY_PRIZES.map(value => (
                        <MenuItem value={value.id} key={value.id}>
                          {value.description}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    label="Título*"
                    value={prizeTitle}
                    fullWidth
                    onChange={e => setPrizeTitle(e.target.value)}
                    disabled={isLoading || isReadOnly}
                    required
                    maxLength={70}
                    error={hasAttemptedSubmit && errors.prizeTitle?.hasError}
                    helperText={
                      hasAttemptedSubmit
                        ? errors.prizeTitle?.message || rules.prizeTitle[0].message
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    label="Título secundario*"
                    value={prizeShortTitle}
                    fullWidth
                    onChange={e => setPrizeShortTitle(e.target.value)}
                    disabled={isLoading || isReadOnly}
                    required
                    maxLength={100}
                    error={hasAttemptedSubmit && errors.prizeShortTitle?.hasError}
                    helperText={
                      hasAttemptedSubmit
                        ? errors.prizeShortTitle?.message || rules.prizeShortTitle[0].message
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Grid container className={classes.iconUploadContainer}>
                    <Grid item xs={6} className={classes.iconUploadButton}>
                      <UploadButton
                        id="campaign-prize-icon-upload-button"
                        accept=".jpg, .jpeg, .png"
                        label={
                          existingPrize && prizeIconPreview
                            ? 'Cambiar icono del reward'
                            : 'Subir icono del reward*'
                        }
                        onChange={handlePrizeIconChange}
                        maxSizeInMB={2}
                        disabled={isReadOnlyOrStarted}
                      />
                      {hasAttemptedSubmit && errors.prizeIcon?.hasError && (
                        <Typography
                          variant="caption"
                          color="error"
                          style={{ marginTop: 4, display: 'block' }}
                        >
                          {errors.prizeIcon.message}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <div className={classes.iconUploadPreviewContainer}>
                        {prizeIconPreview && (
                          <img src={prizeIconPreview} alt="" className={classes.iconPreview} />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Integración section */}
                {hasAnyIntegration && (
                  <>
                    <Grid item xs={12}>
                      <Typography className={classes.dialogSubTitle} style={{ marginTop: 20 }}>
                        Integración
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <PartnerIntegration
                        hideTitle
                        storesEnabled={storesEnabled}
                        setStoresEnabled={isReadOnlyOrStarted ? noop : setStoresEnabled}
                        tucanEnabled={tucanEnabled}
                        setTucanEnabled={isReadOnlyOrStarted ? noop : setTucanEnabled}
                        toteatEnabled={toteatEnabled}
                        setToteatEnabled={isReadOnlyOrStarted ? noop : setToteatEnabled}
                        tucanCategory={tucanCategory}
                        setTucanCategory={isReadOnlyOrStarted ? noop : setTucanCategory}
                        toteatCategory={toteatCategory}
                        setToteatCategory={isReadOnlyOrStarted ? noop : setToteatCategory}
                        currentSku={currentSku}
                        setCurrentSku={isReadOnlyOrStarted ? noop : setCurrentSku}
                        skusList={skusList}
                        setSkusList={isReadOnlyOrStarted ? noop : setSkusList}
                        toteatBenefitId={toteatBenefitId}
                        setToteatBenefitId={isReadOnlyOrStarted ? noop : setToteatBenefitId}
                        errors={errors}
                        isLoading={isLoading}
                        onValidationChange={handlePartnerValidationChange}
                        disabled={isReadOnlyOrStarted}
                        showErrors={hasAttemptedSubmit}
                      />
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
        </TabPanel>

        {/* Tab 3 Horarios - Solo se muestra si activeReward es true */}
        {activeReward && (
          <TabPanel value={tabIndex} index={3} id="time-restriction">
            <TimeRestrictionConfig
              config={timeRestriction}
              onChange={setTimeRestriction}
              disabled={isLoading || isReadOnly}
              hideTimeSelectors={isEcardEnabled}
            />
          </TabPanel>
        )}

        {/* Tab 4 Push (o Tab 3 si no hay Horarios) */}
        <TabPanel value={tabIndex} index={activeReward ? 4 : 3} id="push">
          <Grid container spacing={3}>
            <Grid item xs={12} className={classes.topCheckbox}>
              <CustomFormControlLabel
                control={
                  <CustomCheckbox
                    onChange={e => setActivePush(e.target.checked)}
                    checked={activePush}
                    disabled={isReadOnlyOrStarted}
                  />
                }
                label="Sale con push?"
              />
            </Grid>

            {activePush && (
              <>
                <Grid item xs={12}>
                  <CustomTextField
                    label="Título push*"
                    value={pushTitle}
                    fullWidth
                    required
                    maxLength={30}
                    error={hasAttemptedSubmit && errors.pushTitle?.hasError}
                    helperText={
                      hasAttemptedSubmit && errors.pushTitle?.hasError
                        ? errors.pushTitle?.message
                        : ''
                    }
                    onChange={e => setPushTitle(e.target.value)}
                    disabled={isLoading || isReadOnlyOrStarted}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    label="Descripción push*"
                    value={pushDescription}
                    fullWidth
                    required
                    multiline
                    maxLength={100}
                    error={hasAttemptedSubmit && errors.pushDescription?.hasError}
                    helperText={
                      hasAttemptedSubmit && errors.pushDescription?.hasError
                        ? errors.pushDescription?.message
                        : ''
                    }
                    onChange={e => setPushDescription(e.target.value)}
                    disabled={isLoading || isReadOnlyOrStarted}
                  />
                </Grid>
                {showPushImageUpload && activeReward && (
                  <Grid item xs={12}>
                    <Grid container className={classes.iconUploadContainer}>
                      <Grid item xs={6} className={classes.iconUploadButton}>
                        <UploadButton
                          id="campaign-prize-image-upload-button"
                          accept=".jpg, .jpeg, .png"
                          label={
                            existingPrize && prizeImagePreview
                              ? 'Cambiar imagen de la push'
                              : 'Subir imagen de la push*'
                          }
                          onChange={handlePrizeImageChange}
                          maxSizeInMB={2}
                          disabled={isReadOnlyOrStarted}
                        />
                        {hasAttemptedSubmit && errors.prizeImage?.hasError && (
                          <Typography
                            variant="caption"
                            color="error"
                            style={{ marginTop: 4, display: 'block' }}
                          >
                            {errors.prizeImage.message}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        <div className={classes.iconUploadPreviewContainer}>
                          {prizeImagePreview && (
                            <img src={prizeImagePreview} alt="" className={classes.iconPreview} />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </TabPanel>
        {campaignPopUpsEnabled && (
          <TabPanel value={tabIndex} index={popUpTabIndex} id="pop-up">
            <Grid container spacing={3}>
              <Grid item xs={12} className={classes.topCheckbox}>
                <CustomFormControlLabel
                  control={
                    <CustomCheckbox
                      onChange={e => setActivePopUp(e.target.checked)}
                      checked={activePopUp}
                      disabled={isReadOnly || isCampaignStarted}
                    />
                  }
                  label="Activar Pop-up"
                />
              </Grid>

              {activePopUp && (
                <>
                  <Grid item xs={12}>
                    <Grid container className={classes.iconUploadContainer}>
                      <Grid item xs={6} className={classes.iconUploadButton}>
                        <UploadButton
                          id="update-campaign-pop-up-image-upload-button"
                          accept=".jpg, .jpeg, .png, .webp"
                          label="Subir imagen del pop-up*"
                          onChange={handlePopUpImageChange}
                          maxSizeInMB={2}
                          disabled={
                            isLoading || isReadOnly || isCampaignStarted || isUploadingPopUpImage
                          }
                        />
                        <Typography variant="caption" display="block" style={{ marginTop: 4 }}>
                          Formato vertical recomendado 9:16. Máximo 2MB (PNG, JPG, WebP).
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <div className={classes.iconUploadPreviewContainer}>
                          {popUpImagePreview && (
                            <img
                              src={popUpImagePreview}
                              alt=""
                              className={classes.iconPreview}
                              style={{ aspectRatio: '9 / 16', objectFit: 'cover' }}
                            />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
          </TabPanel>
        )}

        {campaignEmailEnabled && (
          <TabPanel value={tabIndex} index={emailTabIndex} id="email">
            <Grid container spacing={3}>
              <Grid item xs={12} className={classes.topCheckbox}>
                <CustomFormControlLabel
                  control={
                    <CustomCheckbox
                      onChange={e => setActiveEmail(e.target.checked)}
                      checked={activeEmail}
                      disabled={isReadOnlyOrStarted}
                    />
                  }
                  label="Enviar email?"
                />
              </Grid>

              {activeEmail && (
                <>
                  <Grid item xs={12}>
                    <CustomTextField
                      label="Asunto*"
                      value={emailSubject}
                      fullWidth
                      required
                      maxLength={CAMPAIGN_EMAIL_SUBJECT_MAX_LENGTH}
                      error={hasAttemptedSubmit && errors.emailSubject?.hasError}
                      helperText={
                        hasAttemptedSubmit
                          ? errors.emailSubject?.message || rules.emailSubject[0].message
                          : ''
                      }
                      onChange={e => setEmailSubject(e.target.value)}
                      disabled={isLoading || isReadOnlyOrStarted}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomTextField
                      label="HTML*"
                      value={emailHtml}
                      fullWidth
                      required
                      multiline
                      rows={10}
                      error={hasAttemptedSubmit && errors.emailHtml?.hasError}
                      helperText={
                        hasAttemptedSubmit
                          ? errors.emailHtml?.message || rules.emailHtml[0].message
                          : `${emailHtml.length} / ${CAMPAIGN_EMAIL_HTML_MAX_LENGTH}`
                      }
                      onChange={e => setEmailHtml(e.target.value)}
                      disabled={isLoading || isReadOnlyOrStarted}
                      inputProps={{ maxLength: CAMPAIGN_EMAIL_HTML_MAX_LENGTH }}
                    />
                  </Grid>
                  {emailHtml.trim().length > 0 && (
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                        Preview
                      </Typography>
                      <iframe
                        title="email-preview"
                        srcDoc={emailHtml}
                        sandbox=""
                        style={{
                          width: '100%',
                          minHeight: 360,
                          border: '1px solid #ddd',
                          borderRadius: 4,
                          background: '#fff',
                        }}
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </TabPanel>
        )}
      </Grid>
    </Dialog>
  )
}

UpdateCampaignDialog.defaultProps = {
  isReadOnly: false,
}

export { UpdateCampaignDialog }
